import React, { useEffect, useState } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import axios from "axios";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Inactive, Active } from "../../shared/ActivaInactive";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  rounded: 2,
};

const SubscriptionUserPlan = () => {
  const [data, setData] = useState([]);
  const [details, setDetails] = useState([]);
  const [customerData, setCustomerData] = useState({});
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [open1, setOpen1] = React.useState(false);
  const handleOpen1 = () => setOpen1(true);
  const handleClose1 = () => setOpen1(false);
  const [details1, setDetails1] = useState([]);
  const [customerData1, setCustomerData1] = useState({});
  const [open2, setOpen2] = React.useState(false);
  const handleOpen2 = () => setOpen2(true);
  const handleClose2 = () => setOpen2(false);
  const [details2, setDetails2] = useState([]);
  const StoreID = localStorage.getItem("store_id");

  const subscriptonList = () => {
    axios
      .get(
        `https://app1.crazzyhub.com/api/admin/user-list-subscribe-plan/?store_id=${StoreID}`,
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        setData(response?.data?.data);
      })
      .catch((error) => {
        console.log("", error);
      });
  };

  useEffect(() => {
    subscriptonList();
  }, []);

  const viewDetailList = (event, subName, row) => {
    event.preventDefault();
    if (subName === "Daily") {
      setDetails(row?.daily_sub);
      setCustomerData(row?.customer);
      handleOpen();
    } else if (subName === "Monthly") {
      setDetails1(row?.monthly_sub);
      setCustomerData1(row?.customer)
      handleOpen1();
    } else if (subName === "Weekly") {
      setDetails2(row?.weekly_days_sub);
      handleOpen2();
    }
  };
  // 
  console.log("weekly data==>", details);

  return (
    <div className=" !bg-slate-100">
      <div className="flex justify-between">
        <div className="p-2">
          <p className="text-xl !text-black font font-bold">
            User SubscriptionAdmin List
          </p>
        </div>
        <div className="m-2"></div>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="child-modal-title"
          aria-describedby="child-modal-description"
        >
          <Box sx={{ ...style, width: 430 }} className="rounded-2xl !border-0">
            <div
              id="child-modal-title "
              className="!text-black !text-center !text-xl"
            >
              Daily Subscription Details{" "}
              <Button
                onClick={handleClose}
                variant="contained"
                className="relative !bg-gray-300 top-[-33px] !font-bold !text-gray-900 right-[-58px]"
              >
                X
              </Button>
            </div>
            <hr />
            <div className="text-sm mt-2">
              <div className="flex justify-between">
                <div>Name</div>
                <div>{customerData?.first_name ? customerData?.first_name : "--"}</div>
              </div>
              <div className="flex justify-between">
                <div>Mobile Number</div>
                <div>{customerData?.mobile_no}</div>
              </div>
              <div className="flex justify-between">
                <div>Password </div>
                <div>{customerData?.password}</div>
              </div>
              <div className="flex justify-between">
                <div>Join Date </div>
                <div>{customerData?.date_joined?.slice(0,10)}</div>
              </div>
              <div className="flex justify-between">
                <div>Start Date</div>
                <div>{details[0]?.start_date}</div>
              </div>
              <div className="flex justify-between">
                <div>End Date</div>
                <div>{details[0]?.end_date}</div>
              </div>
              <div className="flex justify-between">
                <div>QUANTITY</div>
                <div>{details[0]?.quantity}</div>
              </div>
              <div className="flex justify-between">
                <div>remaining_delivery</div>
                <div>{details[0]?.remaining_delivery}</div>
              </div>
              <div className="flex justify-between">
                <div>is_active</div>
                <div>{customerData?.is_active ? <Active/> : <Inactive/>}</div>
              </div>
              <div className="flex justify-between">
                <div>Is Pad</div>
                <div>{details[0]?.subscription?.is_paid ? <span className="bg-slate-300 text-green-500 font-bold px-9 py-[2px] rounded-xl">yes</span> : <span className="bg-slate-300 text-red-500 font-bold px-10 py-[2px] rounded-xl">no</span>}</div>
              </div>
            </div>
          </Box>
        </Modal>
        <Modal
          open={open1}
          onClose={handleClose1}
          aria-labelledby="child-modal-title"
          aria-describedby="child-modal-description"
        >
          <Box sx={{ ...style, width: 430 }} className="rounded-2xl !border-0">
            <div
              id="child-modal-title "
              className="!text-black !text-center !text-xl"
            >
              Monthly Subscription Details{" "}
              <Button
                onClick={handleClose1}
                variant="contained"
                className="relative !bg-gray-300 top-[-33px] !font-bold !text-gray-900 right-[-40px]"
              >
                X
              </Button>
            </div>
            <hr />
            <div className="text-sm mt-2">
              <div className="flex justify-between">
                <div>Name</div>
                <div>{customerData1?.first_name ? customerData1?.first_name : "--"}</div>
              </div>
              <div className="flex justify-between">
                <div>Mobile Number</div>
                <div>{customerData1?.mobile_no}</div>
              </div>
              <div className="flex justify-between">
                <div>Password </div>
                <div>{customerData1?.password}</div>
              </div>
              <div className="flex justify-between">
                <div>Join Date </div>
                <div>{customerData1?.date_joined?.slice(0,10)}</div>
              </div>
              <div className="flex justify-between">
                <div>Start Date</div>
                <div>{details1[0]?.start_date}</div>
              </div>
              <div className="flex justify-between">
                <div>End Date</div>
                <div>{details1[0]?.end_date}</div>
              </div>
              <div className="flex justify-between">
                <div>QUANTITY</div>
                <div>{details1[0]?.monthly_sub_date_quantity[0]?.quantity}</div>
              </div>
              <div className="flex justify-between">
                <div>remaining_delivery</div>
                <div>{details1[0]?.remaining_delivery}</div>
              </div>
              <div className="flex justify-between">
                <div>is_active</div>
                <div>{customerData1?.is_active ? <Active/> : <Inactive/>}</div>
              </div>
              <div className="flex justify-between">
                <div>Is Pad</div>
                <div>{details1[0]?.subscription?.is_paid ? <span className="bg-slate-300 text-green-500 font-bold px-9 py-[2px] rounded-xl">yes</span> : <span className="bg-slate-300 text-red-500 font-bold px-10 py-[2px] rounded-xl">no</span>}</div>
              </div>
            </div>
          </Box>
        </Modal>
        <Modal
          open={open2}
          onClose={handleClose2}
          aria-labelledby="child-modal-title"
          aria-describedby="child-modal-description"
        >
          <Box sx={{ ...style, width: 430 }} className="rounded-2xl !border-0">
            <div
              id="child-modal-title "
              className="!text-black !text-center flex justify-between !text-xl"
            >
             <div>Weekly Subscription Details</div>
              <div className="relative top-[-33px] left-8"><Button
                onClick={handleClose2}
                variant="contained"
                className="!bg-gray-300 !font-bold !text-gray-900"
              >
                X
              </Button></div>
            </div>
            <hr />
            <div className="text-sm mt-2">
              <div className="flex justify-between">
                <div>Name</div>
                <div>{customerData1?.first_name ? customerData1?.first_name : "--"}</div>
              </div>
              <div className="flex justify-between">
                <div>Mobile Number</div>
                <div>{customerData1?.mobile_no}</div>
              </div>
              <div className="flex justify-between">
                <div>Password </div>
                <div>{customerData1?.password}</div>
              </div>
              <div className="flex justify-between">
                <div>Join Date </div>
                <div>{customerData1?.date_joined?.slice(0,10)}</div>
              </div>
              <div className="flex justify-between">
                <div>Start Date</div>
                <div>{details2[0]?.start_date ? details2[0]?.start_date :"--"}</div>
              </div>
              <div className="flex justify-between">
                <div>End Date</div>
                <div>{details1[0]?.end_date}</div>
              </div>
              <div className="flex justify-between">
                <div>QUANTITY</div>
                <div>{details1[0]?.monthly_sub_date_quantity[0]?.quantity}</div>
              </div>
              <div className="flex justify-between">
                <div>remaining_delivery</div>
                <div>{details1[0]?.remaining_delivery}</div>
              </div>
              <div className="flex justify-between">
                <div>is_active</div>
                <div>{customerData1?.is_active ? <Active/> : <Inactive/>}</div>
              </div>
              <div className="flex justify-between">
                <div>Is Pad</div>
                <div>{details1[0]?.subscription?.is_paid ? <span className="bg-slate-300 text-green-500 font-bold px-9 py-[2px] rounded-xl">yes</span> : <span className="bg-slate-300 text-red-500 font-bold px-10 py-[2px] rounded-xl">no</span>}</div>
              </div>
            </div>
          </Box>
        </Modal>
      </div>
      <div className="flex flex-col !rounded !text-black bg-slate-100 shadow-card shadow-zinc-600 m-2">
        <div className="flex items-center justify-between my-2">
          <span className="flex  gap-3">
            <input
              type="text"
              className="!border-3 !border-black !w-72 mx-3 px-2 rounded-md py-1"
              placeholder="search"
              style={{ border: "1px solid black" }}
            />
          </span>
        </div>
        <TableContainer
          component={Paper}
          // sx={{  }}
          sx={{ width: "100%", maxHeight: 440 }}
          className="!text-black !mx-auto !bg-white overflow-auto px-2"
        >
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                {/* <TableCell className="!text-left !p-2">
                  <Checkbox className="!m-0 !text-black" />
                </TableCell> */}
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  SR. NO.
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  CUSTOMER NUMBER
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  CUSTOMER NAME
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  PRODUCT NAME
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  SUBSCRIPTION TYPE
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  START DATE
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  END DATE
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  DELIVERIES REMAINING
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  VIEW
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody className="!bg-red">
              {data &&
                data?.map((row, index) => (
                  <TableRow key={row.id} className="!text-slate-700">
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row.id ? row.id : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.customer?.mobile_no
                        ? row?.customer?.mobile_no
                        : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.customer?.first_name
                        ? row?.customer?.first_name
                        : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.product_variant?.product_variant_name
                        ? row?.product_variant?.product_variant_name
                        : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.subscription_choice?.subscription_name ===
                      "Daily" ? (
                        <div className="bg-green-300 text-white p-1 rounded-lg font-bold">
                          {row?.subscription_choice?.subscription_name}
                        </div>
                      ) : null}
                      {row?.subscription_choice?.subscription_name ===
                      "Monthly" ? (
                        <div className="bg-red-300 text-white p-1 rounded-lg font-bold">
                          {row?.subscription_choice?.subscription_name}
                        </div>
                      ) : null}
                      {row?.subscription_choice?.subscription_name ===
                      "Weekly" ? (
                        <div className="bg-orange-300 text-white p-1 rounded-lg font-bold">
                          {row?.subscription_choice?.subscription_name}
                        </div>
                      ) : null}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.start_date ? row?.start_date : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.end_date ? row?.end_date : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.deliveries_remaining
                        ? row?.deliveries_remaining
                        : "--"}
                    </TableCell>

                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {/* <BorderColorIcon
                        className="!text-green-500"
                        onClick={(event)=>viewDetailList(event,row?.subscription_choice?.subscription_name,row)}
                      /> */}
                      <Button
                        variant="outlined"
                        size="small"
                        color="primary"
                        onClick={(event) =>
                          viewDetailList(
                            event,
                            row?.subscription_choice?.subscription_name,
                            row
                          )
                        }
                      >
                        view
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        <div
          className="!float-right relative bg-white w-[100%] mx-auto bottom-0 right-0 py-3 border-t-2 border-gray-400 !flex-col !justify-end !items-center"
          style={{ marginRight: "0px" }}
        >
          <button className="!float-right">
            <ArrowForwardIosIcon />
          </button>
          <button className="float-right">
            <ArrowBackIosIcon />
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionUserPlan;
